<template>
    <div>
        <v-list
            ><v-list-item v-for="option in purchaseOptions" :key="option.id">
                <v-list-item-content class="py-1">
                    <SoliPurchaseOption
                        :purchaseOption="option"
                        @input="$emit('input', option)"
                /></v-list-item-content>
            </v-list-item>
        </v-list>
    </div>
</template>

<script>
export default {
    props: {
        purchaseOptions: {
            type: Array,
            default: () => [],
        },
    },
};
</script>
